import { useMutation } from '@tanstack/react-query'
import { validateNgBankAccount } from 'services/BeneficiaryService'

export const useNgBankAccountValidationMutation = () => {
  return useMutation({ mutationFn: validateNgBankAccount })
}
